import { hasWorkspaceAccess } from './portalAccess.mjs'

/**
 * Portal-wide module menu — the three active work areas.
 * Used by the Home hub tiles and the workspace shell side menu.
 * Keep ids stable: pages match on them for active-state highlighting.
 */
export const PORTAL_MAIN_MENU = [
  {
    id: 'jobs',
    label: 'Jobs',
    icon: 'CalendarDays',
    description: 'Job tracking and scheduling',
    path: '/jobs-management',
    badge: 'Coming Soon',
  },
  {
    id: 'exchange_desk',
    label: 'Exchange Desk',
    icon: 'Scale',
    description: 'Gold & silver buying operations',
    path: '/exchange-desk',
  },
  {
    id: 'product_listing',
    label: 'Product Listing',
    icon: 'Tag',
    description: 'Product catalog and publishing',
    path: '/product-listing',
  },
];

export function getPortalWorkspaces(role) {
  return PORTAL_MAIN_MENU.filter(item => hasWorkspaceAccess(role, item.id))
}
